module.exports = __webpack_public_path__ + "static/media/curious.447ce07d.svg";